<template>
    <div class="modal fade" id="msg-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="بستن"></button>
                </div>
                <div class="modal-body">
                    <div class="row " dir="rtl">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                        <h3 class="text-center">مشاوره خرید</h3>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-12 mb-3">
                        <input type="tel" name="msg-phone" class="form-control text-end" placeholder="شماره تماس" v-model="phone">
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-12 mb-3">
                        <input type="text" name="msg-name" class="form-control" placeholder="نام و نام خانوادگی" v-model="name">
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                        <textarea name="msg-text" class="form-control" placeholder="متن پیام" v-model="text"></textarea>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-3 text-center">
                        <button aria-label="ارسال" type="submit" class="btn btn-secondary" :disabled="!text || !name || phone.length !== 11 " @click="sendData()">ارسال</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
  name: 'MsgModal',
  data () {
    return {
      phone: this.$User ? this.$User.username : '',
      name: this.$User ? this.$User.name : '',
      text: ''
    }
  },
  methods: {
    sendData: function () {
      const mutation = `
      mutation msg {
        msg(phone: "${this.phone}", text: "${this.text}", name:"${this.name}") {
          status
        }
      }
      `
      this.$fetchGraphQL(mutation)
        .then(res => {
          if (res.data.msg.status === 'success') {
            this.phone = ''
            this.name = ''
            this.text = ''
            this.fire({
              icon: 'success',
              title: 'در اسرع وقت با شما تماس گرفته می‌شود',
              showConfirmButton: false,
              timer: 2000
            })
          } else {
            this.fire({
              icon: 'error',
              title: 'شماره تماس را به صورت صحیح وارد کنید',
              showConfirmButton: false,
              timer: 2000
            })
          }
        })
    }
  },
  mounted () {}
}
</script>
<style scoped>
.spinner-grow{
    margin:60px;
}
.modal-content{
    min-width: 300px;
    max-width: 500px;
    direction: rtl;
    text-align: center;
    border: none;
    border-radius: 24px;
}
.modal-header .btn-close{
    margin: -.5rem auto -.5rem -.5rem;
}
.modal-header{
    border-bottom: none;
}

.modal-dialog {
    position: relative;
    width: auto;
    margin: 10vh auto;
    pointer-events: none;
    max-width: fit-content;
}
button{
  width: min-content;
}
.w{
  width: -moz-available;
  width: -webkit-fill-available;
  margin: 2rem;
}
.flx{
  display: flex;
  flex-direction: column;
  justify-content: center;
}
p {
  color:rgba(0,0,0,.55);
}
</style>
